import React, { useEffect, useState } from 'react';

import { formatCurrency } from '@coingecko/cryptoformat';
import {
  Stack,
  Table,
  TableBody,
  TableContainer,
  TablePagination,
  Typography
} from '@mui/material';
import dayjs from 'dayjs';

import { TextRenderer } from '../../cellRenderers/TextRenderer';
import { getComparator, stableSort } from '../../utils/utils';
import { StyledCellText, StyledTableCell, StyledTableRow } from '../styled';

import { TableHeader } from './TableHeader';

export const CommonTable = (props) => {
  const { columns, idoData, onRowClick } = props;
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('calories');
  const [tableData, setTableData] = useState([]);
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  useEffect(() => {
    idoData.pages.forEach((page) => {
      setTableData([...tableData, ...page.items]);
    });
  }, [idoData]);

  return (
    <>
      <TableContainer>
        <Table stickyHeader aria-label="sticky table">
          <TableHeader
            order={order}
            orderBy={orderBy}
            onRequestSort={handleRequestSort}
            columns={columns}
          />
          <TableBody>
            {stableSort(tableData, getComparator(order, orderBy)).map((row) => {
              return (
                <StyledTableRow
                  hover
                  role="checkbox"
                  tabIndex={-1}
                  key={row.code}
                  onClick={() => onRowClick(row)}>
                  <StyledTableCell key={'token_name'} style={{ maxWidth: 160 }}>
                    <Stack direction="row" alignItems="center">
                      {row.logo_url && (
                        <img
                          src={row.logo_url}
                          height="30px"
                          width="30px"
                          style={{ borderRadius: '50%', paddingRight: '4px' }}
                        />
                      )}

                      <StyledCellText>{`${row['token_name']}`}</StyledCellText>
                      <Typography sx={{ fontSize: '0.9em', color: '#8c8ca5', pl: 0.5 }}>
                        {`${row['ticker']}`}
                      </Typography>
                    </Stack>
                  </StyledTableCell>

                  <StyledTableCell key={'ecosystems'} style={{ maxWidth: 170 }}>
                    <StyledCellText>
                      {row['ecosystems'].map((item) => item.ecosys_name).join(',')}
                    </StyledCellText>
                  </StyledTableCell>
                  <StyledTableCell key={'categories'} style={{ maxWidth: 170 }}>
                    <StyledCellText>
                      {row['categories'].map((item) => item.category_name).join(',')}
                    </StyledCellText>
                  </StyledTableCell>
                  <StyledTableCell key={'investors'}>
                    <TextRenderer data={row['investors']} />
                  </StyledTableCell>
                  <StyledTableCell key={'launch_mkt_cap'}>
                    <StyledCellText>
                      {row['launch_mkt_cap'] && formatCurrency(row['launch_mkt_cap'], 'USD')}
                    </StyledCellText>
                  </StyledTableCell>

                  <StyledTableCell key={'launch_date'}>
                    <StyledCellText>
                      {dayjs(row['launch_date']).isValid()
                        ? dayjs(row['launch_date']).utc().format('D MMM, YYYY')
                        : ''}
                    </StyledCellText>
                  </StyledTableCell>

                  <StyledTableCell key={'launch_end_date'}>
                    <StyledCellText>
                      {dayjs(row['launch_end_date']).isValid()
                        ? dayjs(row['launch_end_date']).utc().format('D MMM, YYYY')
                        : ''}
                    </StyledCellText>
                  </StyledTableCell>

                  <StyledTableCell key={'ido_price'}>
                    <StyledCellText>
                      {row['ido_price'] && formatCurrency(row['ido_price'], 'USD')}
                    </StyledCellText>
                  </StyledTableCell>
                </StyledTableRow>
              );
            })}
            {tableData?.length == 0 > 0 && (
              <StyledTableRow
                style={{
                  height: 53 * tableData?.length == 0
                }}>
                <StyledTableCell colSpan={6}>
                  <Typography
                    variant="h6"
                    noWrap
                    component="div"
                    sx={{
                      display: { xs: 'flex', sm: 'flex' },
                      justifyContent: { xs: 'center', sm: 'center' }
                    }}>
                    No Records Found
                  </Typography>
                </StyledTableCell>
              </StyledTableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        rowsPerPageOptions={[]}
        component="div"
        count={tableData.length}
        rowsPerPage={tableData.length}
        page={0}
      />
    </>
  );
};
